import {
  SET_ACCOUNTS,
  SET_ASSETS,
  SET_EXPENSES,
  SET_NETWORTH,
  SET_YEARS,
  SET_CO_BRAND_TOKEN,
  SET_USER_SESSION_TOKEN,
} from './actionTypes'
import ACCOUNT_DATA from './../mock/accounts.json'

const initialState = {
  assets: 0,
  expenses: 30000,
  netWorth: 750000,
  years: 30,
  cobSessionToken: null,
  userSessionToken: null,
  accounts: ACCOUNT_DATA.account,
}

const yodlee = (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSETS:
      return Object.assign({}, state, { assets: parseFloat(action.assets, 10) })
    case SET_EXPENSES:
      return Object.assign({}, state, {
        expenses: parseFloat(action.expenses, 10),
      })
    case SET_NETWORTH:
      return Object.assign({}, state, {
        netWorth: parseFloat(action.netWorth, 10),
      })
    case SET_YEARS:
      return Object.assign({}, state, { years: parseFloat(action.years, 10) })
    case SET_CO_BRAND_TOKEN:
      return Object.assign({}, state, {
        cobSessionToken: action.cobSessionToken,
      })
    case SET_USER_SESSION_TOKEN:
      return Object.assign({}, state, {
        userSessionToken: action.userSessionToken,
      })
    case SET_ACCOUNTS:
      return Object.assign({}, state, { accounts: action.accounts })
    default:
      return state
  }
}

export default yodlee



// WEBPACK FOOTER //
// ./api/yodlee/reducer.js